<div class="header">
    <a href="" class="logo">Registration</a>
</div>